<template>
    <div>
        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <v-tab class="font-weight-black">INGRESOS / EGRESOS</v-tab>
            <!-- <v-tab class="font-weight-black">ACUERDOS DE PAGOS</v-tab> -->
            <v-tab class="font-weight-black">NOTA DE CRÉDITO / DÉBITO</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item class="py-4">
                <ingresoEgresoComp></ingresoEgresoComp>
            </v-tab-item>

            <!-- <v-tab-item class="py-4">
                <acuerdoComp></acuerdoComp>
            </v-tab-item> -->

            <v-tab-item class="py-4">
                <notaCreditoDebitoComp></notaCreditoDebitoComp>
            </v-tab-item>
        </v-tabs-items>


    </div>
</template>

<style>
.btn_block_style3 {
    background-color: #E53935 !important;
}

.btn_block_style4 {
    background-color: #4caf50 !important;
}

.v-data-table__checkbox {
    text-align: center !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    background: var(--v-secondary-base) !important
}

.theme--dark.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    background: var(--v-secondary-base) !important
}
</style>

<script>

import IngresoEgresoComp from './components/IngresoEgresoComp.vue'
// import AcuerdoComp from './components/AcuerdoComp.vue'
import NotaCreditoDebitoComp from './components/NotaCreditoDebitoComp.vue'

export default {
    data() {
        return {
            tab: 0
        }
    },
    components: {
        ingresoEgresoComp: IngresoEgresoComp,
        // acuerdoComp: AcuerdoComp,
        notaCreditoDebitoComp: NotaCreditoDebitoComp
    },

}

</script>